"use client"

import { useEffect } from "react"
import { Button } from "@/components/ui/button"

declare global {
  interface Window {
    dataLayer: any[];
  }
}

type variant =
  | "default"
  | "defaultRounded"
  | "blackRounded"
  | "greenRounded"
  | "lightBlueRounded"
  | "destructive"
  | "action"
  | "actionRounded"
  | "outline"
  | "customOutline"
  | "customImpactGreenOutlineRounded"
  | "customOutlineRounded"
  | "customBlueOutline"
  | "secondary"
  | "success"
  | "successRounded"
  | "dangerRounded"
  | "card"
  | "ghost"
  | "ghostImpactGreen"
  | "link"
  | "dark"
  | "web"
  | "webBlue"
  | "beige"
  | "impactGreen"
  | "impactBlack"
  | "orange";


export default function EventButton (props: {lang: string, event: any, selector: string, text: Array<string>, buttonVariant?: variant}) {

  useEffect(() => {
      const handleClick = () => {
        if (typeof window !== 'undefined') {
          window.dataLayer.push(props.event);
        }
      };

      const button = document.querySelector(props.selector);
      if (button) {
        button.addEventListener('click', handleClick);
      }

      return () => {
        if (button) {
          button.removeEventListener('click', handleClick);
        }
      };
  }, []);

  const buttonVariant: variant = props.buttonVariant ? props.buttonVariant : 'defaultRounded';

  return (
    <Button variant={buttonVariant} className={`p-4 rounded-3xl mt-5 ${props.selector.startsWith('.') ? props.selector.slice(1) : props.selector}`}>      
        { props.lang === 'en' ? props.text[0] : props.text[1] }
    </Button>
  );
};